// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"_1Lilo","current":"_17SIf","breadcrumbsElement":"_3T0f4","inHeader":"_1MHqY"};